import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  cardActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: '16px',
    gap: '15px',
  },
  button: {
    minWidth: '125px',
  },
  buttonCancel: {
    minWidth: '125px',
  },
  alias: {
    marginTop: 0,
  },
  hint: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#1b3958',
  },
  viewSiteButton: {},
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginBottom: 6,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, -2px) scale(1)',
      },
    },
  },
}));
